import React from 'react';
import Icon from 'components/AppIcon';

export default function FilterToolbar({ filters, onChange, resultCount }) {
  const stages = ['All', 'Operational', 'In Construction'];
  const sectors = ['All', 'Renewable Energy', 'Transport', 'Digital Infrastructure', 'Utilities'];
  const regions = ['All', 'United Kingdom', 'Spain', 'Portugal', 'Germany', 'Sweden'];
  const irrRanges = ['All', '< 8%', '8–12%', '12–16%', '> 16%'];

  const select = (key, val) => onChange({ ...filters, [key]: val });

  const FilterGroup = ({ label, options, filterKey }) => (
    <div className="flex flex-col gap-1">
      <span className="font-caption text-muted-foreground" style={{ fontSize: '0.7rem', letterSpacing: '0.05em', textTransform: 'uppercase' }}>{label}</span>
      <div className="flex flex-wrap gap-1.5">
        {options?.map((opt) => (
          <button
            key={opt}
            onClick={() => select(filterKey, opt)}
            className={`px-3 py-1 rounded-full text-xs font-medium border transition-all duration-150 ${
              filters?.[filterKey] === opt
                ? 'bg-primary text-primary-foreground border-primary'
                : 'bg-background text-muted-foreground border-border hover:border-primary/50 hover:text-foreground'
            }`}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <div className="card" style={{ padding: '16px 20px' }}>
      <div className="flex flex-wrap gap-6 items-end justify-between">
        <div className="flex flex-wrap gap-6">
          <FilterGroup label="Stage" options={stages} filterKey="stage" />
          <FilterGroup label="Sector" options={sectors} filterKey="sector" />
          <FilterGroup label="Region" options={regions} filterKey="region" />
          <FilterGroup label="IRR Range" options={irrRanges} filterKey="irrRange" />
        </div>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Filter" size={14} />
          <span className="font-caption">{resultCount} result{resultCount !== 1 ? 's' : ''}</span>
        </div>
      </div>
    </div>
  );
}
